import axios from 'axios';
import authHeader from "../auth-header";

const API_URL_FETCH = process.env.VUE_APP_ROOT_API+'ticketsList/';
const API_URL_FETCH_MY_TICKETS = process.env.VUE_APP_ROOT_API+'myTicketsList/';

class TicketService {
    getAll() {
        return axios
            .get(API_URL_FETCH, {
                headers:
                    authHeader(),
                params: {

                }
            })
            .then(response => {
                return response.data;

            })
            .catch(err => window.console.log(err));
    }

    getMyTickets() {
        return axios
            .get(API_URL_FETCH_MY_TICKETS, {
                headers:
                    authHeader(),
                params: {

                }
            })
            .then(response => {
                return response.data;
            })
            .catch(err => window.console.log(err));
    }
}

export default new TicketService();
